import { render, staticRenderFns } from "./blis.vue?vue&type=template&id=38f073ba&scoped=true&"
import script from "./blis.vue?vue&type=script&lang=js&"
export * from "./blis.vue?vue&type=script&lang=js&"
import style0 from "./blis.vue?vue&type=style&index=0&id=38f073ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f073ba",
  null
  
)

export default component.exports